import React from "react";

/** This component is a placeholder for formatting inside CardsList */
const NarrowCardPlaceholder = () => (
  <div className="presentation-card presentation-card-narrow card-placeholder" />
);

export default NarrowCardPlaceholder;
